import React, { useContext } from "react";
import { connect } from "react-redux";
import { Context } from "@components/useContext/context";
import ImageContainer from "@components/imageContainer";
import { resolvePath } from "@utils/resolvePath";
import {
  CardWrapper,
  HeaderSection,
  HeaderNumber,
  HeaderQuote,
  Divider,
  ContentBox,
  MainText,
  ContentDivider,
  SubText
} from "./styles";

interface InsuranceLieCardProps {
  is_visible?: boolean;
  actions?: any;
  lieNumber?: string;
  lieQuote?: string;
  mainText?: string;
  subText?: string;
  linkText?: string;
  linkUrl?: string;
  headerColor?: string;
  mainTextColor?: string;
  backgroundColor?: string;
  onInsuranceLieCardClick?: () => void;
}

const InsuranceLieCard = (props: InsuranceLieCardProps) => {
  const {
    is_visible = true,
    lieNumber,
    lieQuote,
    mainText,
    subText,
    onInsuranceLieCardClick
  } = props;

  return (
    <CardWrapper>
      <HeaderSection>
        <HeaderNumber>{lieNumber}</HeaderNumber>
        <HeaderQuote
          dangerouslySetInnerHTML={{
            __html: lieQuote
          }}
        />
      </HeaderSection>
      <Divider />
      <ContentBox>
        <MainText
          dangerouslySetInnerHTML={{
            __html: mainText
          }}
        />
        <ContentDivider />
        <SubText
          dangerouslySetInnerHTML={{
            __html: subText
          }}
          onClick={onInsuranceLieCardClick}
        />
      </ContentBox>
    </CardWrapper>
  );
};

export default connect()(InsuranceLieCard);
